function getDefaultConfig() {
  const appEnv = (process.env.REACT_APP_ENV || process.env.NODE_ENV) as "development" | "production" | "test" | "staging" | undefined;

  switch (appEnv) {
    case "development":
      return "https://development.tms.api.bjshomedelivery.com/v1";

    case "staging":
      return "https://staging.tms.api.bjshomedelivery.com/v1";

    case "production":
      return "https://development.tms.api.bjshomedelivery.com/v1";

    default:
      return "https://development.tms.api.bjshomedelivery.com/v1";
  }
}

function getBaseEndpoint() {
  return getDefaultConfig();
}

export default getBaseEndpoint;
